<template>
  <GetInTouchFormSection v-if="openGetInTouchForm" @closeForm="openGetInTouchForm = false" />
  <!-- No v-show gate here any more.
       This was `v-show="showBannerImage"`, a flag that started false and was
       flipped to true in mounted(). It bought nothing: Vue only creates this
       element during mount anyway, so the flag could never reveal it any
       sooner than mount - it could only hold it back. What it did buy was a
       guaranteed second render pass before the hero became visible, and this
       section contains the page's LCP element (div.mea-pattern, the large
       "MEA" watermark). Measured on the live site: FCP 400 ms, LCP 2764 ms.
       It also meant the layout below had no width while it was hidden, which
       is why Slick initialised the client-logo strip against a zero-width
       container - see PatnersView.vue. -->
  <section class="zohoMea-hero" id="home-section">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-12">
          <div class="mea-pattern">{{ content.watermark }}</div>
          <div class="row align-items-center">
            <div class="col-lg-7">
              <h1 class="hero-head" data-aos="fade-up">
                <span class="text-primary-main" style="background: linear-gradient(268deg, #009BFC 17.89%, #0467FB 82%) !important; -webkit-background-clip: text !important; -webkit-text-fill-color: transparent !important; background-clip: text !important; font-size: 70px !important;">{{ content.mainTitle }}</span><br />
              </h1>
              <h2 class="hero-head-title" data-aos="fade-up">
                <span>{{ content.titleDescription }}</span>
                <br />
              </h2>
              <div class="excerpt">
                <p
                  class="mb-4"
                  data-aos="fade-zoom-in"
                  data-aos-easing="ease-in-back"
                  data-aos-offset="0"
                >
                 {{ content.description }}
                </p>
                <router-link :to="content.button.to"
                  class="btn cta-primary"
                  data-aos="fade-up"
                  data-aos-anchor-placement="top-bottom"
                  >{{ content.button.label }}
                  <!-- <img src="https://measiteassetpublic.zohostratus.in/img/index/Right Arrow.svg" style="width: 12px;"></img> -->
                  <img :width="content.button.icon.width" :height="content.button.icon.height" :src="content.button.icon.src" style="width: 12px; height: auto;"></img>
                </router-link>
              </div>
            </div>
            <div class="col-lg-4 ml-auto" style="margin-left: 50px;">
              <div class="hero-banner">
                <div class="hero-pattern1" style="z-index: 0;"></div>
                <!-- <img
                  src="https://measiteassetpublic.zohostratus.in/img/index/main-banner-n-compressed-3-2.png"
                  alt="Image"
                  class="img-fluid"
                  data-aos="zoom-in"
                /> -->
                <!-- <img
                  src="https://measiteassetpublic.zohostratus.in/img/index/final-home-banner-image-compressed-2x.png"
                  alt="Image"
                  class="img-fluid"
                  data-aos="zoom-in"
                /> -->
                <img :width="content.image.width" :height="content.image.height"
                  :src="content.image.src"
                  :alt="content.image.alt"
                  class="img-fluid"
                  data-aos="zoom-in"
                  fetchpriority="high"
                />
                <!-- <img
                  src="https://loginimages-development.zohostratus.in/final-home-banner-image-compressed-3x.png"
                  alt="Image"
                  class="img-fluid"
                  data-aos="zoom-in"
                /> -->

                <div class="hero-pattern2"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import GetInTouchFormSection from './GetInTouchFormSection.vue';
import homeContent from '@/assets/home-content.json';

export default {
  name: "HomeMainSection",
  components: {
    GetInTouchFormSection
  },
  props: {
    // HomeView passes this block explicitly. The default means the section
    // still renders its own copy if it is ever mounted without the prop.
    content: {
      type: Object,
      default: () => homeContent.HomeMainSection
    }
  },
  data() {
    return {
      openGetInTouchForm: false
    }
  }
};
</script>

<style>
  .text-primary-main {
    background: linear-gradient(268deg, #009BFC 17.89%, #0467FB 82%) !important;
    -webkit-background-clip: text !important;
    -webkit-text-fill-color: transparent !important;
    background-clip: text !important;
  }
</style>